import { fmtCurrency } from "./utils";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

import S from "./review-styled";
import { Table } from "./styled";

S.Table = Table;

export default function ReviewTable({ items, handleRemove, totals }) {
	return (
		<S.Table>
			<thead>
				<tr>
					<th className="qty">Qty</th>
					<th className="left">Item</th>
					<th className="total">Total</th>
				</tr>
			</thead>

			<tbody>
				{items.map((item, index) => {
					const subtotal = item.qty * item.amt;
					return (
						<tr key={index}>
							<td className="center">
								<span className="larger">{item.qty}</span>
							</td>
							<td>
								<S.Item>
									<div>
										<img src={item.giftcard.img} alt="Gift Card" />
										<div style={{ textAlign: "left" }}>
											<span className="larger">{item.name}</span>
											<ul>
												<li>{`Delivery: ${item.delivery}`}</li>
												<li>{`Recipient: ${item.recipient.fname} ${item.recipient.lname} (${item.recipient.email}) `}</li>
											</ul>

											{item.recipient.comments && (
												<small>{item.recipient.comments}</small>
											)}
										</div>
									</div>

									<button type="button" onClick={() => handleRemove(index)}>
										<FontAwesomeIcon icon={faTrashAlt} size="lg" />
									</button>
								</S.Item>
							</td>
							<td className="right">{fmtCurrency(subtotal / 100)}</td>
						</tr>
					);
				})}
			</tbody>
			<tfoot>
				<tr>
					<td colSpan="2" className="right orderHeading">
						TOTAL
					</td>
					<td className="right">{fmtCurrency(totals.total / 100)}</td>
				</tr>
			</tfoot>
		</S.Table>
	);
}
